import React, { useEffect, useState } from "react";
import { moneyFormat, queryHandler } from "../../lib/global_functions";
import { Col, Row, Tag, Typography } from "antd";
import { PictureOutlined } from "@ant-design/icons";
import { GetDataListFromServer } from "../../lib/api";
import { QUERY_AGENT_BANK } from "../../lib/query_obj";
import { AGENT_BANK_LIST } from "../../lib/config";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

const { Text } = Typography;
export default function ExpandableContent({ record }) {
  const { access_token } = useSelector((state) => state.user);

  const [agentBankList, setAgentBankList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filter, setFilter] = useState({
    name: "",
    order_by: "created_at",
    order_type: "DESC",
  });

  const [pagin, setPagin] = useState({
    page_number: 1,
    per_page: 10,
    total: 0,
  });

  const BANK_ICON_MAP = {
    KBZ_PAY: "/assets/kbz pay.svg",
    WAVE_PAY: "/assets/wave pay.svg",
    AYA_PAY: "/assets/aya pay.svg",
    CB_PAY: "/assets/cb pay.svg",
    CB_BANK: "/assets/cb bank.svg",
    AYA_BANK: "/assets/aya bank.svg",
    KBZ_BANK: "/assets/kbz bank.svg",
  };
  function renderBankOption(value) {
    const iconPath = BANK_ICON_MAP[value];
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={iconPath}
          alt={value}
          style={{ width: 30, height: 30, marginRight: 8, borderRadius: "5px" }}
        />
      </div>
    );
  }

  async function getAgentBankData(page_number, per_page) {
    setLoading(true);
    await GetDataListFromServer(
      AGENT_BANK_LIST,
      queryHandler(filter, QUERY_AGENT_BANK, { page_number, per_page }),
      access_token
    )
      .then(({ data: { data: res, total } }) => {
        setLoading(false);
        const activeBanks = Array.isArray(res)
          ? res.filter((bank) => bank.is_active === true)
          : [];
        setAgentBankList(activeBanks);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  useEffect(() => {
    getAgentBankData(pagin.page_number, pagin.per_page);
  }, []);

  const matchedAgentBank = agentBankList.find(
    (bank) => bank.id === record?.agent_bank_account_id
  );

  console.log("matchedl agent ban", matchedAgentBank)

  return (
    <Row gutter={24}>
      <Col span={12}>
        {record.receipt_url ? (
          <img style={{ width: "100%" }} src={record.receipt_url} alt="slip" />
        ) : (
          <div
            style={{
              width: "100%",
              border: "1px solid white",
              padding: "300px 0px",
              textAlign: "center",
            }}
          >
            <PictureOutlined
              style={{
                fontSize: "68px",
                color: "#bfbfbf",
                marginBottom: "16px",
              }}
            />
            <br />
            <Text type="secondary">No photo available</Text>
          </div>
        )}
      </Col>
      <Col span={12}>
        <Row gutter={[12, 12]}>
          <Col span={8}>
            <Text>Bank Transaction ID</Text>
          </Col>
          <Col span={16}>
            <Text copyable>{record.bank_transaction_id}</Text>
          </Col>
          <Col span={8}>
            <Text>Transaction Type</Text>
          </Col>

          <Col span={16}>
            <Tag color={record.type === "DEPOSIT" ? "lime" : "orange"}>
              <Text
                style={{ color: record.type === "DEPOSIT" ? "lime" : "orange" }}
              >
                {record.type}
              </Text>
            </Tag>
          </Col>
          <br />
          <br />

          <Col span={8}>
            <Text>Game Points</Text>
          </Col>
          <Col span={16}>
            <Text>
              {moneyFormat(
                record?.wallet?.game_points || record.game_points || "-"
              )}
            </Text>
          </Col>

          <Col span={8}>
            <Text>Withdraw Request Points</Text>
          </Col>
          <Col span={16}>
            <Text>
              {moneyFormat(
                record?.wallet?.withdraw_request_points ||
                  record.withdraw_request_points ||
                  "-"
              )}
            </Text>
          </Col>

          <br />
          <br />
          <Col span={8}>Agent Bank Account Name</Col>
          <Col span={16}>
            <Text>{matchedAgentBank?.acc_name || "-"}</Text>
          </Col>

          <Col span={8}>Agent Bank Account Number</Col>
          <Col span={16}>
            <Text>{matchedAgentBank?.acc_number || "-"}</Text>
          </Col>

          <Col span={8}>Agent Bank Type</Col>
          <Col span={16}>
            {renderBankOption(matchedAgentBank?.bank_type || "-")}
          </Col>

          <Col span={8}>
            <Text>Before Agent Transaction</Text>
          </Col>
          <Col span={16}>
            <Text style={{ color: "mediumaquamarine" }}>
              {moneyFormat(record.agent_old_points || 0)}
            </Text>
          </Col>
          <Col span={8}>
            <Text>After Agent Transaction</Text>
          </Col>
          <Col span={16}>
            <Text style={{ color: "cyan" }}>
              {moneyFormat(record.agent_new_points || 0)}
            </Text>
          </Col>

          <br />
          <br />

          <Col span={8}>User Bank Accont Name</Col>
          <Col span={16}>{record.user_bank?.acc_name}</Col>
          <Col span={8}>User Bank Accont Number</Col>
          <Col span={16}>{record.user_bank?.acc_number}</Col>
          <Col span={8}>User Bank Type</Col>
          <Col span={16}>
            <Row align="middle">
              <Col>{renderBankOption(record.user_bank?.bank_type)}</Col>
            </Row>
          </Col>
          <Col span={8}>User Last Deposit Bank</Col>
          <Col span={16}>{record.last_deposit_bank_type || "-"}</Col>
          <Col span={8}>Before Transaction</Col>
          <Col span={16} style={{ color: "mediumaquamarine" }}>
            {moneyFormat(record.old_points)}
          </Col>
          <Col span={8}>Points</Col>
          <Col span={16}>{moneyFormat(record.points)}</Col>
          <Col span={8}>After Transaction</Col>
          <Col span={16} style={{ color: "cyan" }}>
            {moneyFormat(record.new_points)}
          </Col>
          <br />
          <br />

          <Col span={8}>
            <Text>Approve</Text>
          </Col>
          <Col span={16}>
            <Text>
              <Tag color={record.is_approved ? "lime" : "red"}>
                <Text style={{ color: record.is_approved ? "lime" : "red" }}>
                  {record.is_approved ? "Yes" : "No"}
                </Text>
              </Tag>
            </Text>
          </Col>
          <Col span={8}>
            <Text>Finish</Text>
          </Col>
          <Col span={16}>
            <Text>
              <Tag color={record.is_finish ? "lime" : "red"}>
                <Text style={{ color: record.is_finish ? "lime" : "red" }}>
                  {record.is_finish ? "Yes" : "No"}
                </Text>
              </Tag>
            </Text>
          </Col>

          <Col span={8}>
            <Text>Operator</Text>
          </Col>
          <Col span={16}>
              <Text>{record.operator_id || "-"}</Text>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
